var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9478_26588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8663 17.2265L18.1863 14.72L22.4527 17.2265L18.1863 19.68L13.8663 17.28V17.2265ZM0.90625 9.8135L18.1863 0L31.0398 7.3065L26.7733 14.72L18.1868 9.8135L5.22675 17.1735L0.90625 9.8135Z",
    fill: "#F6BD3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8666 27.0398V22.1332L18.1331 19.6798L22.4531 17.2262V22.1327L18.1866 24.5863V29.4928L13.8666 31.9998V27.0398ZM13.8666 17.2262L9.54656 14.7727L5.22656 17.1728V12.2663L18.1866 4.90625V14.7198L13.8666 17.2262ZM26.7201 12.2663V9.81275L31.0401 7.30625L31.0936 12.2128L26.7736 14.7192L26.7201 12.2663Z",
    fill: "#EB8C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54625 29.3862V14.7733L13.8127 12.3733L13.8663 17.2267L18.1863 19.6268V24.5868L13.8663 22.2933V31.9998L9.54625 29.3862ZM3.03975 15.8933L0.90625 14.6132V9.81325L5.22625 12.2668V17.1733L3.03975 15.8933ZM18.1863 9.81325V4.90625L26.7197 9.81275L26.7733 14.7192L18.1868 9.81275L18.1863 9.81325Z",
    fill: "#E35A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9478_26588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo12);
export default __webpack_public_path__ + "static/media/logo12.a7284148ad02c16f6567df5a5cdd4c6b.svg";
export { ForwardRef as ReactComponent };